/*
  Damano: Panels für Menü (links) und Filter (unten).
  <d-drawer id="…"> enthält .d-overlay und .d-panel; Auslöser mit data-drawer-open="…".
*/
if (!customElements.get('d-drawer')) {
  class DamanoDrawer extends HTMLElement {
    connectedCallback() {
      this.panel = this.querySelector('.d-panel');
      this.querySelector('.d-overlay')?.addEventListener('click', () => this.close());
      this.querySelectorAll('[data-drawer-close]').forEach((el) => el.addEventListener('click', () => this.close()));
      this.addEventListener('keyup', (event) => {
        if (event.code === 'Escape') this.close();
      });
    }

    open(trigger) {
      this.trigger = trigger || document.activeElement;
      this.setAttribute('open', '');
      this.panel?.setAttribute('aria-hidden', 'false');
      document.querySelectorAll(`[data-drawer-open="${this.id}"]`).forEach((el) => el.setAttribute('aria-expanded', 'true'));
      document.body.classList.add('overflow-hidden');
      if (typeof trapFocus === 'function') trapFocus(this.panel);
    }

    close() {
      if (!this.hasAttribute('open')) return;
      this.removeAttribute('open');
      this.panel?.setAttribute('aria-hidden', 'true');
      document.querySelectorAll(`[data-drawer-open="${this.id}"]`).forEach((el) => el.setAttribute('aria-expanded', 'false'));
      document.body.classList.remove('overflow-hidden');
      if (typeof removeTrapFocus === 'function') removeTrapFocus(this.trigger);
    }
  }

  customElements.define('d-drawer', DamanoDrawer);

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-drawer-open]');
    if (!trigger) return;
    const drawer = document.getElementById(trigger.dataset.drawerOpen);
    if (!drawer) return;
    event.preventDefault();
    drawer.open(trigger);
  });
}

/* «Tasche n» auf dem Telefon mit dem neu gerenderten Desktop-Zähler abgleichen. */
document.addEventListener('DOMContentLoaded', () => {
  const bubble = document.getElementById('cart-icon-bubble');
  if (!bubble) return;
  const sync = () => {
    const count = bubble.querySelector('[data-cart-bubble-count]')?.dataset.cartBubbleCount;
    if (count === undefined) return;
    document.querySelectorAll('[data-cart-count]').forEach((el) => (el.textContent = count));
  };
  new MutationObserver(sync).observe(bubble, { childList: true, subtree: true });
});

/* «Tasche n» auf dem Telefon öffnet dieselbe Tasche wie der Desktop-Link. */
document.addEventListener('click', (event) => {
  const toggle = event.target.closest('[data-cart-toggle]');
  const drawer = document.querySelector('cart-drawer');
  if (!toggle || !drawer) return;
  event.preventDefault();
  drawer.open(toggle);
});
